import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { UserDetails } from './UserDetails';
import { UserDirectory } from './UserDirectory';
import { UserEdit } from './UserEdit';
import { getUserName } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './Users.translations.json';
import { UserCreate } from './UserCreate';
import { UserBreadcrumbsData } from './UserBreadcrumbs';
import { SectionContextProvider } from '../../common/SectionContext';
import { NotFound } from '../NotFound';

const { addTranslations, Translation } = i18nNsFactory('users');
addTranslations(translations);

export const USER_ROUTES = [
  {
    path: '/',
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.users')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <UserDirectory />,
      },
      {
        path: path.userView,
        renderBreadcrumb: (data?: UserBreadcrumbsData) =>
          data?.user ? (
            getUserName(data.user)
          ) : (
            <Translation>{(t) => t('breadcrumb.user-details')}</Translation>
          ),
        children: [
          {
            index: true,
            element: <UserDetails />,
          },
          {
            path: path.userEdit,
            renderBreadcrumb: () => (
              <Translation>{(t) => t('breadcrumb.user-edit')}</Translation>
            ),
            element: <UserEdit />,
          },
        ],
      },
      {
        path: path.userCreate,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.user-create')}</Translation>
        ),
        element: <UserCreate />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export interface UsersProps {
  basePath: string;
}

export const Users: FC<UsersProps> = ({ basePath }) => (
  <SectionContextProvider basePath={basePath}>
    {useRoutes(onBasePath(basePath, USER_ROUTES))}
  </SectionContextProvider>
);
